import React from "react";
import { ChevronRightIcon } from "../icons";

const MegaMenuLink = ({ href, children }) => (
  <a className="bv-mega-header__menu-link" href={href}>
    <span className="bv-mega-header__menu-link-text">{children}</span>
    <ChevronRightIcon className="bv-mega-header__menu-link-icon" size={16} />
  </a>
);

export default MegaMenuLink;
